import { createAction } from '@reduxjs/toolkit';

import type { DialogsCentral } from './types';

export const changeWebBankingModal = createAction<DialogsCentral['isOpen']>('dialogs/webBanking-modal');
